
import React from "react";
import { AccountMenuItem, i18nManager } from "../../../../../i18n";
import { IPlatform } from "../../../../../services";
import { NavLink, Route, Routes, useSearchParams } from "react-router-dom";
import Faqs from "./Faqs";
import { Utils } from "../../../../../utils";
import { Elements } from "../../../../shared";
import Categories from "./Categories";
import Communities from "./Communities";
import Contacts from "./Contacts";
import Resources from "./Resources";
import Articles from "./Articles";

export interface SupportProps {
    platform?: IPlatform;
}

function Support(props: SupportProps) {
    const [searchParams, _] = useSearchParams(window.location.search);
    const search = Utils.urlParamsToSearch(searchParams, ["platform_id"]);
    const labels = i18nManager.Labels.dashboard.platform_management.management.support;

    return (<div className="content support">
        {!props.platform
            ? (<div style={{ margin: "auto"}}>{Elements.LOADING_STATE}</div>)
            : (<React.Fragment>
                <div className="menu">
                    {labels.menu.map((item: AccountMenuItem) => (<NavLink key={item.label} to={{ pathname: item.location, search }}>
                        {item.label}
                    </NavLink>))}
                </div>
                <Routes>
                    <Route path="/faqs" element={<Faqs platform={props.platform!} />} />
                    <Route path="/contacts" element={<Contacts platform={props.platform!} />} />
                    <Route path="/articles" element={<Articles platform={props.platform!} />} />
                    <Route path="/resources" element={<Resources platform={props.platform!} />} />
                    <Route path="/categories" element={<Categories platform={props.platform!} />} />
                    <Route path="/communities" element={<Communities platform={props.platform!} />} />
                </Routes>
            </React.Fragment>)}
    </div>);
}

export default Support;
